
import Vue from 'vue';
import { TransformedLmJobList } from '~/transforms/transformModules';

export default Vue.extend({
  props: {
    data: {
      type: Object as () => TransformedLmJobList['data'],
      required: true,
    },
  },
  data() {
    return {
      ready: false,
    };
  },
  head() {
    return {
      script: [
        {
          src: this.ready ? 'https://static.b-ite.com/jobs-api/loader-v1/api-loader-v1.min.js' : '',
        },
      ],
    };
  },
  computed: {
    getBiteID() {
      return process.env.BITE_JOB_LISTING_ID;
    },
  },
  methods: {
    urlEncodeQueryParams() {
      const encodedQuery =
        this.data.listquery && this.data.listquery.length
          ? Object.fromEntries(new URLSearchParams(this.data.listquery))
          : {};
      const currentQuery = this.$route.query || {};
      return { ...currentQuery, ...encodedQuery };
    },
  },
  async mounted() {
    if (this.data.listquery?.length || this.$route.query) {
      await this.$router.push({ query: this.urlEncodeQueryParams() });
      this.ready = true;
    } else {
      this.ready = true;
    }
  },
});
